import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/partner/page.jsx");
